module.exports = __webpack_public_path__ + "static/media/star-half-alt.092d0916.svg";